"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = isBrowser;
const constants_1 = require("../script/constants");
/**
 * Checks if the code is running in the browser.
 */
function isBrowser() {
    // eslint-disable-next-line no-underscore-dangle
    return Boolean(typeof window !== 'undefined' && window[constants_1.PUBLIC_ENV_KEY]);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtYnJvd3Nlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oZWxwZXJzL2lzLWJyb3dzZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFLQSw4QkFHQztBQVJELG1EQUFxRDtBQUVyRDs7R0FFRztBQUNILFNBQWdCLFNBQVM7SUFDdkIsZ0RBQWdEO0lBQ2hELE9BQU8sT0FBTyxDQUFDLE9BQU8sTUFBTSxLQUFLLFdBQVcsSUFBSSxNQUFNLENBQUMsMEJBQWMsQ0FBQyxDQUFDLENBQUM7QUFDMUUsQ0FBQyJ9